import { Button, InputText } from "@sellar-io/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import * as ROUTES from "../../../constants/routes";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { usePriceListCreate } from "../../../hooks/api/v2/priceList/usePriceListCreate";

export const BasePriceListCreateDialog = ({
  active,
  setActive,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const createBasePriceList = usePriceListCreate();

  const onSubmit = () => {
    createBasePriceList.mutate(
      {
        name,
        derivationType: "base",
      },
      {
        onSuccess: (response) => {
          setActive(false);
          navigate(ROUTES.PRICE_LIST.href({ priceListId: response.id }), {
            state: { isNewBase: true },
          });
        },
      },
    );
  };

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="New base price list"
      />
      <DialogContent>
        <InputLabel>Name</InputLabel>
        <InputContainer>
          <InputText
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </InputContainer>
      </DialogContent>
      <DialogCTA>
        <Button
          disabled={!name}
          loading={createBasePriceList.isPending}
          onClick={onSubmit}
        >
          Create
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
